// extracted by mini-css-extract-plugin
export default {"agreement":"Agreement_agreement__pp3-0","agreementTitle":"Agreement_agreementTitle__micqZ"};